import React, { Component } from 'react';
import { Link } from 'react-router';
import Translate from '../layout/Translate';

class Sidebar extends Component {


  render() {


    return (

		<div className="container__sidebar container__sidebar_align_right sidebar">
			<div className="sidebar__title">
				<Translate slug="discount__title" />
			</div>
			<table className="sidebar__discount discount">
				<tbody>
				<tr className="sidebar__row ">
					<td className="sidebar__period"><Translate slug="discount__6" /></td>
					<td className="sidebar__period"><Translate slug="discount__8" /></td>
					<td className="sidebar__period"><Translate slug="discount__10" /></td>
				</tr>
				<tr className="sidebar__row">
					<td className="sidebar__percent sidebar__percent_5">5%</td>
					<td className="sidebar__percent sidebar__percent_10">7%</td>
					<td className="sidebar__percent sidebar__percent_20">10%</td>
				</tr>
				<tr className="sidebar__row">
					<td colSpan="3" className="sidebar__conditions">
						<Translate slug="discount__pay" />
					</td>
				</tr>
				</tbody>
			</table>
			<p className="sidebar__info">
				<Translate slug="discount__terms" />
			</p>
			<div className="disclaimer">
				<Translate slug="discount__note" />
			</div>
		</div>
    );
  }
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/common/components/layout/Sidebar.js